import { Delete } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { get } from "radash";
import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { Controller, UseControllerProps } from "react-hook-form";

export type FileInputProps = UseControllerProps<any> & {
  label: string;
  dragAndDrop?: boolean;
  allowedTypes?: string[];
};

const FileInput = (props: FileInputProps) => {
  const { control, name, label, dragAndDrop = false, allowedTypes = ["PDF"], ...rest } = props;

  // Ensure extensions have a leading dot for the 'accept' attribute
  const formattedAcceptTypes = allowedTypes
    .map((type) => {
      if (type.includes("/") || type.startsWith(".")) return type;
      return `.${type}`;
    })
    .join(",");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: state }) => (
        <FormControl fullWidth>
          {dragAndDrop ? (
            <Box>
              <FileUploader
                handleChange={async (file: File) => {
                  field.onChange(file);
                }}
                children={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px dashed",
                      borderColor: "text.primary",
                      borderRadius: "8px",
                      padding: "30px",
                      width: "fit-content",
                      cursor: "pointer",
                    }}
                  >
                    {field.value ? (
                      <Typography variant="body1">
                        {_.get(field.value, "name", field.value)}
                      </Typography>
                    ) : (
                      <Typography variant="body1">
                        DRAG & DROP or CLICK here to upload document
                      </Typography>
                    )}
                    {field.value && (
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => field.onChange(null)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </Box>
                }
                name={name}
                types={allowedTypes}
                style={{ cursor: "pointer" }}
              />
            </Box>
          ) : (
            <Box display="flex" flexDirection="row" gap={1} alignItems="center">
              <Input
                type="file"
                error={!!get(state.errors, name)}
                inputProps={{
                  accept: formattedAcceptTypes,
                  sx: {
                    width: "fit-content",
                  },
                }}
                {...field}
                onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    field.onChange(file);
                  } else {
                    field.onChange(null);
                  }
                }}
                value={null}
                {...rest}
              />
              {field.value && (
                <>
                  <Typography variant="body1" sx={{ alignSelf: "center" }} noWrap>
                    {_.get(field.value, "name", field.value)}
                  </Typography>
                  <IconButton color="error" size="small" onClick={() => field.onChange(null)}>
                    <Delete />
                  </IconButton>
                </>
              )}
            </Box>
          )}
        </FormControl>
      )}
    />
  );
};

export default FileInput;
